module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      'height': _vm.height.replace(';', '')
    })
  }, [_c('VirtualScroller', {
    ref: "scroller",
    staticClass: "selector-pw-container",
    attrs: {
      "items": _vm.items,
      "item-height": _vm.itemHeight,
      "buffer": "200",
      "pool-size": "300"
    },
    nativeOn: {
      "scroll": function($event) {
        return _vm.onScroll($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;
        var itemIndex = ref.itemIndex;

        return [_c('SelectorItem', {
          attrs: {
            "item": item,
            "index": itemIndex,
            "onSelect": _vm.onSelect,
            "focusEl": _vm.focusEl
          }
        }, [_vm._t("default", null, {
          index: itemIndex,
          item: item,
          focusEl: _vm.focusEl
        })], 2)]
      }
    }])
  }, [_c('template', {
    slot: "before-content"
  }, [_vm._t("beforeContent", null, {
    focusEl: _vm.focusEl
  })], 2)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46920958"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/HelpersPW/SelectorPW.vue
// module id = 374
// module chunks = 2